// src/pages/HomePage.jsx
import React from "react";
import Layout from "../components/Layout";
import Card from "../components/Card";
import Button from "../components/Button";
import withT from "../hocs/withT";
import { Trans } from "react-i18next";
import "./HomePage.css";

const HomePage = ({ t }) => {
  return (
    <div className="home-page">  
      <Layout>
        <h1 className="appname-title">
          {/* Using <Trans> to safely render inline markup */}
          <Trans i18nKey="home.title" components={[<em key="0" />]} />
        </h1>
        <p className="subtitle">{t("home.subtitle")}</p>
        <Button label={t("home.ctaPrimary")} onClick={() => window.location.href="/create"} />
        <Card title={t("home.cardTitle")}>
          <div className="steps">
            <div className="step">
              <span className="icon-number">1</span>
              <p className="card-details">
                <Trans i18nKey="home.step1" components={[<u key="0" />]} />
              </p>
            </div>
            <div className="step">
              <span className="icon-number">2</span>
              <p className="card-details">{t("home.step2")}</p>
            </div>
            <div className="step">
              <span className="icon-number">3</span>
              <p className="card-details">{t("home.step3")}</p>
            </div>
            <div className="step">
              <span className="icon-emoticone">😍</span>
              <p className="card-details-footer"><strong>{t("home.cardFooter")}</strong></p>
            </div>
          </div>
        </Card>
        <Button label={t("home.ctaSecondary")} onClick={() => window.location.href="/create"} />
        <p className="asterix" style={{ whiteSpace: "pre-line" }}>{t("home.disclaimer")}</p>
      </Layout>
    </div>
  );
};

export default withT(HomePage);
